import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getReportSchedules } from 'services/TransactionExportService'

export const useReportScheduleQuery = (walletId: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: reactQueryKeys.reportSchedules(walletId),
    queryFn: () => getReportSchedules(walletId),
    enabled,
    select: response => {
      return response?.content
    },
  })
}
